import { render } from "./SingleImgSlider.vue?vue&type=template&id=6e097106&scoped=true"
import script from "./SingleImgSlider.vue?vue&type=script&lang=js"
export * from "./SingleImgSlider.vue?vue&type=script&lang=js"

import "./SingleImgSlider.vue?vue&type=style&index=0&id=6e097106&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e097106"]])

export default __exports__